export default "__VITE_ASSET__64b3382d__"